import { message } from "antd";
import jwtDecode from "jwt-decode";

const hardcodeToken = process.env.REACT_APP_DEV_TOKEN || "";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue('token');
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}

export const getUserInfoFromToken = () => {
  try {
    const token = getWorkWiseAuthToken();

    if (!token) return null;

    const decoded = jwtDecode(token);

    return decoded || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};
export const isRespectiveDocument = (documentId) => {
  const pathname = window.location.pathname;
  const id = pathname.split("/")[1];
  return id && id === documentId;
};


export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};

export const processTemplateData = (serverResponse) => {
  let templateData = serverResponse?.data?.data || null;
  if (templateData?.milepadData) {
    try {
      const rawData = JSON.parse(templateData.milepadData);
      delete templateData.milepadData;
      templateData.mindmapData = rawData;
    } catch (error) {
      console.error('Failed to parse template milepadData:', error);
      delete templateData.milepadData;
      templateData.mindmapData = {};
    }
  }
  return templateData;
};

export const removeTemplateIdFromURL = (history) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('templateId');
  const newSearch = searchParams.toString();
  // If a history-like object with replace is provided, use it (react-router v6 compatibility).
  if (history && typeof history.replace === 'function') {
    history.replace({
      pathname: window.location.pathname,
      search: newSearch ? `?${newSearch}` : ''
    });
    return;
  }

  // Fallback: use the browser history API to replace the current URL without reloading.
  try {
    const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '');
    if (window.history && typeof window.history.replaceState === 'function') {
      window.history.replaceState(null, '', newUrl);
    }
  } catch (err) {
    console.error('Failed to remove templateId from URL:', err);
  }
};

export const createUpdatePayload = (type, data) => {
  switch (type) {
    case 'position':
      return { position: data };
    case 'name':
      return { data: { label: data } };
    case 'style':
      return { style: data };
    case 'properties':
      return {
        data: {
          label: data.label,
          nodeBg: data.nodeBg,
          textBg: data.textBg,
        },
        type: data.type
      };
    case 'color':
      return data; // For updateMany, payload is the nodes array
    default:
      return data;
  }
};

export const updateFileSize = (data, setSavingData) => {
  try {
    const size = new TextEncoder().encode(JSON.stringify(data)).length || 0;
    setSavingData({
      isSaving: "",
      lastSavedDateTime: "",
      fileSize: formatFileSize(size),
    });
  } catch (error) {
    console.error('Failed to calculate file size:', error);
    setSavingData({
      isSaving: "",
      lastSavedDateTime: "",
      fileSize: formatFileSize(0),
    });
  }
};